/**
 * @fileoverview GET handler for the "/oauth/validate_authorization_request" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { oauthValidateAuthorizationRequest } from "./constants";
import type {
  OAuthAuthorizationRequestParams,
  OAuthAuthorizationRequestValidationError,
  OAuthAuthorizationRequestValidationResult,
} from "./types";
import { isOAuthAuthorizationRequestValidationResult } from "./validators";

export const getOAuthValidateAuthorizationRequest = reactQueryFetcherAdapter(
  oauthValidateAuthorizationRequest,
  createGetFetcherFunctionWithShadowError<OAuthAuthorizationRequestValidationError>()(
    (
      signal: AbortSignal,
      authorizationRequest: OAuthAuthorizationRequestParams
    ): Promise<OAuthAuthorizationRequestValidationResult> => {
      return fetch(
        "/oauth/validate_authorization_request",
        "GET",
        authorizationRequest,
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isOAuthAuthorizationRequestValidationResult
);
